import React, { useState } from "react";
import { AppBar, Toolbar, Typography } from "@material-ui/core";
import { useLocation } from "react-router-dom";
import Help from "./Help";
import ImageSets from "./ImageSets";
import { useStyles } from "src/styles/NavBarStyles";

/**
 * This Container is used for navigation bar at the top of the page.
 */
 const NavBar: React.FunctionComponent = () => {
    const styles = useStyles();

    const getInitialState = (path: string) => {
        if (path == "/canonicalImages" || path.includes("/canonicalImages/")) {
            return "Canonical Images";
        } else {
            return "Sample Item Images";
        }
    }

    const [imageSetsName, setImageSetsName] = useState(getInitialState(useLocation().pathname));

    return (   
        <AppBar position="sticky" className={styles.navBar}>
            <Toolbar variant='dense'>
                <Typography variant="body1" className={styles.title}>Item Matrix | Item Image Gallery</Typography>
                <ImageSets imageSetsName={imageSetsName} setImageSetsName={setImageSetsName}/>
                <div className={styles.flow}></div>
                <Help imageSetsName={imageSetsName}/>
            </Toolbar>
        </AppBar>      
    ); 
}

export default NavBar;
